import React from 'react'

const FindTutorFilterItem = ({ children, onClick, isActive }) => {
  return (
    <button
      type="button"
      className={`${isActive ? '!bg-primary-75 !border-primary-75 text-white' : 'border-primary-100'} border-[1px] border-solid py-[10px] px-[22px] text-sm bg-white rounded-lg font-semibold transition-colors duration-200 ease`}
      onClick={onClick}
    >
      {children}
    </button>
  )
}

export default FindTutorFilterItem
